// 应用趋势
export function applicationLineEachers (echarts, dataName, lineData, timesData) {
  let myChartPie = echarts.init(document.getElementById("applicationLine"));
  let option = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        lineStyle: {
          color: "rgba(190, 229, 255, .6)"
        },
      },
    },
    legend: {
      top: 17,
      right: 0,
      icon: "rect",
      itemWidth: 11,
      itemHeight: 2,
      itemGap: 11,
      selectedMode: false,
      data: ["人数", "人次"],
      textStyle: {
        fontSize: 12,
        color: "#F1F1F3",
      },
    },
    grid: {
      top: 50,
      left: 0,
      right: 0,
      bottom: 15,
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        boundaryGap: true,
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: "rgba(190, 229, 255, .6)",
          },
        },
        axisLabel: {
          textStyle: {
            fontSize: 10,
            color: "rgba(190, 229, 255, .6)",
          },
          rotate: 30
        },
        splitLine: {
          lineStyle: {
            color: "#57617B",
          },
        },
        data: dataName,
      }
    ],
    yAxis: [
      {
        type: "value",
        minInterval: 1,
        name: "数量",
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: "rgba(190, 229, 255, .6)",
          },
        },
        axisLabel: {
          // margin: 10,
          textStyle: {
            fontSize: 12,
            color: "rgba(190, 229, 255, .6)",
          },
        },
        splitLine: {
          lineStyle: {
            color: "#57617B",
          },
        },
      },
    ],
    series: [
      {
        name: "人数",
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 5,
        showSymbol: false,
        lineStyle: {
          normal: {
            width: 2,
          },
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(66, 232, 255, 0.3)",
                },
                {
                  offset: 0.8,
                  color: "rgba(66, 232, 255, 0)",
                },
              ],
              false
            ),
            shadowColor: "rgba(0, 0, 0, 0.1)",
            shadowBlur: 10,
          },
        },
        itemStyle: {
          normal: {
            color: "rgb(66, 232, 255)",
            borderColor: "rgba(66, 232, 255, 0.27)",
            borderWidth: 12,
          },
        },
        data: lineData,
      },
      {
        name: "人次",
        type: "line",
        smooth: true,
        symbol: "circle",
        symbolSize: 5,
        showSymbol: false,
        lineStyle: {
          normal: {
            width: 2,
          },
        },
        areaStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(255, 170, 42, 0.3)",
                },
                {
                  offset: 0.8,
                  color: "rgba(255, 170, 42, 0)",
                },
              ],
              false
            ),
            shadowColor: "rgba(0, 0, 0, 0.1)",
            shadowBlur: 10,
          },
        },
        itemStyle: {
          normal: {
            color: "rgb(255, 170, 42)",
            borderColor: "rgba(255, 170, 42, 0.2)",
            borderWidth: 12,
          },
        },
        data: timesData,
      }
    ],
    dataZoom: [
      {
        type: "slider",
        show: dataName.length > 7 ? true : false, //flase直接隐藏图形
        xAxisIndex: [0],
        bottom: 15,
        height: 0, // 滚动条高度
        start: 0, //滚动条的起始位置
        end:
          dataName.length <= 7 ? 100 : Math.ceil((7 * 100) / dataName.length), //滚动条的截止位置（按比例分割你的柱状图x轴长度）
        handleColor: "#ddd", //h滑动图标的颜色
        handleStyle: {
          borderColor: "#cacaca",
          borderWidth: "1",
          shadowBlur: 2,
          background: "#ddd",
          shadowColor: "#ddd",
        },
        fillerColor: "#ccc",
        backgroundColor: "#ddd",
        textStyle: false, //隐藏滚动条两边字体
        showDetail: false,
      },
    ],
  }
  myChartPie.setOption(option);
}
export function applicationBarEachers (echarts, useingData) {
  let myChartPie = echarts.init(document.getElementById("applicationBar"));
  let option = {
    // backgroundColor: "#00265f",
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      top: 17,
      right: 0,
      icon: "rect",
      itemWidth: 8,
      itemHeight: 8,
      itemGap: 11,
      selectedMode: false,
      data: ["时长"],
      textStyle: {
        color: "#bee5ff",
      },
    },
    grid: {
      top: "15%",
      right: "3%",
      left: "10%",
      bottom: "12%",
    },
    xAxis: [
      {
        type: "category",
        data: [
          "工具包",
          "知识库",
          "测评"
        ],
        axisLine: {
          lineStyle: {
            color: "rgba(255,255,255,0.12)",
          },
        },
        axisLabel: {
          margin: 10,
          color: "#e2e9ff",
          textStyle: {
            fontSize: 14,
          },
        },
      },
    ],
    yAxis: [
      {
        name: "分钟",
        minInterval: 1,
        axisTick: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: "rgba(190, 229, 255, .6)",
          },
        },
        axisLabel: {
          textStyle: {
            fontSize: 12,
            color: "rgba(190, 229, 255, .6)",
          },
          formatter: function (params) {
            return params
          },
        },
        splitLine: {
          lineStyle: {
            color: "#57617B",
          },
        },
      },
    ],
    series: [
      {
        name: '时长',
        type: "bar",
        data: useingData,
        barWidth: "30px",
        itemStyle: {
          normal: {
            color: new echarts.graphic.LinearGradient(
              0,
              0,
              0,
              1,
              [
                {
                  offset: 0,
                  color: "rgba(0,244,255,1)", // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: "rgba(0,77,167,1)", // 100% 处的颜色
                },
              ],
              false
            ),
            barBorderRadius: [30, 30, 0, 0],
            shadowColor: "rgba(0,160,221,1)",
            shadowBlur: 4,
          },
        },
      },
    ],
  };
  myChartPie.setOption(option);
}


// 心里素养
export function pieEcharts (echarts) {
  let myChartPie = echarts.init(document.getElementById("accomplishmentPie"));
  let option = {
    tooltip: {
      trigger: "item",
      formatter: function (params) {
        return (
          params.data.text
        );
      },
    },
    color: ["#12ffdd", "#ff6d73"],
    legend: {
      data: ["良好", "需关注"],
      right: 20,
      top: 20,
      itemWidth: 11,
      itemHeight: 4,
      selectedMode: false,
      textStyle: {
        color: '#bee5ff',
        fontSize: 12,
      },
    },
    series: [
      {
        type: 'pie',
        radius: ["45%", "60%"],
        center: ["50%", "60%"],
        itemStyle: {
          normal: {
            borderColor: 'rgba(9, 23, 114, 1)',
            borderWidth: 4,
          },
        },
        labelLine: {
          normal: {
            length: 20,
            length2: 60,
            lineStyle: {
              color: "rgba(167, 183, 233, .47)",
            },
          },
        },
        label: {
          normal: {
            formatter: (params) => {
              return (
                "{value|" + params.data.text +
                "}"
              );
            },
            padding: [0, -55, 25, -60],
            rich: {
              value: {
                fontSize: 14,
                color: '#a7b7e9'
              },
            },
          },
        },
        data: [
          { value: 300, name: '良好', text: '升学择业' },
          { value: 480, name: '需关注', text: '社会与适应' },
          { value: 600, name: '需关注', text: '人际交往' },
          { value: 704, name: '良好', text: '学会学习' },
          { value: 635, name: '良好', text: '情绪管理' },
          { value: 480, name: '需关注', text: '认识自我' }
        ]
      }
    ]
  };
  myChartPie.setOption(option);
}

// 桑基图
export function sankeyEcharts (echarts) {

  let data = {
    "nodes": [
      // 一级
      { "name": "心理发展" },
      // 二级

      { "name": "学会学习" },
      { "name": "自我认识" },
      { "name": "人际交往" },
      { "name": "升学择业" },
      { "name": "社会与适应" },
      { "name": "情绪发展" },
      { "name": "其他主题" },
      // 三级(学会学习)下的
      { "name": "学业情绪" },
      { "name": "学习风格" },
      { "name": "学习动机" },
      { "name": "学习状态" },
      { "name": "意志力测评" },
      { "name": "学习压力" },
      { "name": "学习技能" },
      { "name": "学习能力" },
      // 三级(自我认识)下的
      { "name": "人格" },
      { "name": "了解自我" },
      { "name": "自我管理" },
      { "name": "青春期" },
      // 三级(人际交往)下的
      { "name": "同伴交往" },
      { "name": "异性交往" },
      { "name": "师生关系" },
      { "name": "亲子关系" },
      { "name": "人际交往技能" },
      // 三级(升学择业)下的
      { "name": "职业生涯" },
      { "name": "学业生涯" },
      // 三级(社会与适应)下的
      { "name": "整体满意度" },
      { "name": "压力" },
      { "name": "适应" },
      { "name": "应对" },
      { "name": "行为" },
      { "name": "生命健康教育" },
      // 三级(情绪发展)下的
      { "name": "情绪觉察" },
      { "name": "情绪调节" },
      { "name": "情感培养" },
      { "name": "其他类型" },
      //四级(学业情绪)下的
      { "name": "青少年学业情绪问卷" },
      { "name": "考试焦虑量表（TAS）" },
      { "name": "考试焦虑" },
      //四级(学习风格)下的
      { "name": "soloman学习风格量表" },
      //四级(学习动机)下的
      { "name": "成就动机量表" },
      { "name": "学习动力" },
      { "name": "学习动机量表" },
      //四级(学习状态)下的
      { "name": "学习态度与学习方法综合测评量表" },
      { "name": "中学生学习行为综合评定量表" },
      { "name": "青少年学习沉醉感量表" },
      //四级(意志力测评)下的
      { "name": "中学生意志力测验问卷" },
      //四级(学习压力)下的
      { "name": "中学生学习压力源调查问卷（SSS）" },
      //四级(学习技能)下的
      { "name": "青少年时间管理倾向量表" },
      { "name": "目标管理" },
      { "name": "你拖延吗？" },
      //四级(学习能力)下的
      { "name": "多元智能量表" },
      { "name": "情绪智力量表" },
      { "name": "“德才一体”整合智慧量表" },
      { "name": "威廉斯创造力测验" },
      { "name": "思维定势" },
      //四级(人格)下的
      { "name": "艾森克人格问卷（少年版）" },
      { "name": "卡特尔16种人格量表" },
      { "name": "大五人格测试量表" },
      { "name": "12项坚毅性人格量表" },
      { "name": "中文Frost多维度完美主义量表" },
      //四级(了解自我)下的
      { "name": "青少年心理韧性量表" },
      { "name": "心理弹性" },
      { "name": "心理弹性量表" },
      { "name": "悦纳自我" },
      { "name": "自尊量表" },
      { "name": "一般自我效能感量表" },
      //四级(自我管理)下的
      { "name": "中学生自我控制量表" },
      //四级(青春期)下的
      { "name": "青春期逆反心理问卷" },
      //四级(同伴交往)下的
      { "name": "青少年孤独感量表" },
      { "name": "青少年社交焦虑量表" },
      { "name": "父母和同伴依恋量表（IPPA）" },
      //四级(异性交往)下的
      { "name": "相遇在花季" },
      //四级(师生关系)下的
      { "name": "师生关系测验" },
      //四级(亲子关系)下的
      { "name": "中学生亲子关系问卷（学生卷）" },
      { "name": "亲子亲密度问卷" },
      { "name": "父母教养方式量表" },
      { "name": "亲子沟通方式问卷" },
      { "name": "家庭亲密度和适应性量表" },
      //四级(人际交往技能)下的
      { "name": "学会沟通" },
      { "name": "领悟社会支持量表" },
      { "name": "社会支持" },
      { "name": "校园欺凌" },
      { "name": "当冲突在靠近" },
      { "name": "人际边界" },
      //四级(职业生涯)下的
      { "name": "Super职业价值观量表（WVI）" },
      { "name": "职业价值观" },
      { "name": "决策风格" },
      { "name": "生涯规划书" },
      //四级(学业生涯)下的
      { "name": "兴趣知多少" },
      { "name": "入学适应" },
      //四级(整体满意度)下的
      { "name": "多维学生生活满意度量表" },
      //四级(压力)下的
      { "name": "青少年生活事件量表" },
      { "name": "知觉压力量表" },
      { "name": "中小学生压力状态评估问卷" },
      //四级(适应)下的
      { "name": "中学生心理适应性量表" },
      { "name": "思维培养" },
      { "name": "适应变化" },
      //四级(应对)下的
      { "name": "应对方式问卷" },
      { "name": "简易应对方式问卷" },
      //四级(行为)下的
      { "name": "青少年病理性互联网使用量表" },
      { "name": "中学生手机依赖量表" },
      { "name": "青少年攻击性问卷" },
      { "name": "Buss-Warren攻击问卷" },
      { "name": "利他行为量表（SRAS-DR）" },
      { "name": "网络成瘾" },
      //四级(生命健康教育)下的
      { "name": "生命之花" },
      //四级(情绪觉察)下的
      { "name": "情绪我懂你" },
      //四级(情绪调节)下的
      { "name": "情绪调节量表" },
      { "name": "情绪管理" },
      { "name": "掌控情绪" },
      { "name": "情绪调节自我效能感量表" },
      //四级(情感培养)下的
      { "name": "中文版人际反应指针量表" },
      { "name": "青少年宽恕倾向问卷" },
      //四级
      { "name": "中小学生心理健康诊断测验（MHT)" },
      { "name": "PHQ-9抑郁自评量表" },
      { "name": "流调中心抑郁问卷（CES-D）" },
      { "name": "抑郁自评量表" },
      { "name": "焦虑自评量表" },
      { "name": "失眠严重指数量表（ISI）" },
      //五级
      { "name": "偏执" },
      { "name": "焦虑" },
      { "name": "抑郁" },
      { "name": "孤独" },
      { "name": "强迫" },
      { "name": "敌对" },
      { "name": "适应不良" },
      { "name": "恐惧" },
      { "name": "睡眠" },
      { "name": "饮食" },
      { "name": "其他" },
      //六级
      { "name": "心理健康状态" },
    ],

    "links": [
      // 一级
      { "source": "心理发展", "target": "学会学习", "value": 300 },
      { "source": "心理发展", "target": "自我认识", "value": 300 },
      { "source": "心理发展", "target": "人际交往", "value": 300 },
      { "source": "心理发展", "target": "升学择业", "value": 300 },
      { "source": "心理发展", "target": "社会与适应", "value": 300 },
      { "source": "心理发展", "target": "情绪发展", "value": 300 },
      { "source": "心理发展", "target": "其他主题", "value": 300 },
      // 二级(状态评估)下的
      { "source": "其他主题", "target": "其他类型", "value": 150 },
      // 二级(学会学习)下的
      { "source": "学会学习", "target": "学业情绪", "value": 150 },
      { "source": "学会学习", "target": "学习风格", "value": 150 },
      { "source": "学会学习", "target": "学习动机", "value": 150 },
      { "source": "学会学习", "target": "学习状态", "value": 150 },
      { "source": "学会学习", "target": "意志力测评", "value": 150 },
      { "source": "学会学习", "target": "学习压力", "value": 150 },
      { "source": "学会学习", "target": "学习技能", "value": 150 },
      { "source": "学会学习", "target": "学习能力", "value": 150 },
      // 二级(自我认识)下的
      { "source": "自我认识", "target": "人格", "value": 150 },
      { "source": "自我认识", "target": "了解自我", "value": 150 },
      { "source": "自我认识", "target": "自我管理", "value": 150 },
      { "source": "自我认识", "target": "青春期", "value": 150 },
      // 二级(人际交往)下的
      { "source": "人际交往", "target": "同伴交往", "value": 150 },
      { "source": "人际交往", "target": "异性交往", "value": 150 },
      { "source": "人际交往", "target": "师生关系", "value": 150 },
      { "source": "人际交往", "target": "亲子关系", "value": 150 },
      { "source": "人际交往", "target": "人际交往技能", "value": 150 },
      // 二级(升学择业)下的
      { "source": "升学择业", "target": "职业生涯", "value": 150 },
      { "source": "升学择业", "target": "学业生涯", "value": 150 },
      // 二级(社会与适应)下的
      { "source": "社会与适应", "target": "整体满意度", "value": 150 },
      { "source": "社会与适应", "target": "压力", "value": 150 },
      { "source": "社会与适应", "target": "适应", "value": 150 },
      { "source": "社会与适应", "target": "应对", "value": 150 },
      { "source": "社会与适应", "target": "行为", "value": 150 },
      { "source": "社会与适应", "target": "生命健康教育", "value": 150 },
      // 二级(情绪发展)下的
      { "source": "情绪发展", "target": "情绪觉察", "value": 150 },
      { "source": "情绪发展", "target": "情绪调节", "value": 150 },
      { "source": "情绪发展", "target": "情感培养", "value": 150 },
      // 三级(其他类型)下的
      { "source": "其他类型", "target": "中小学生心理健康诊断测验（MHT)", "value": 80 },
      { "source": "其他类型", "target": "PHQ-9抑郁自评量表", "value": 80 },
      { "source": "其他类型", "target": "流调中心抑郁问卷（CES-D）", "value": 80 },
      { "source": "其他类型", "target": "抑郁自评量表", "value": 80 },
      { "source": "其他类型", "target": "焦虑自评量表", "value": 80 },
      { "source": "其他类型", "target": "失眠严重指数量表（ISI）", "value": 80 },
      // 三级(学业情绪)下的
      { "source": "学业情绪", "target": "青少年学业情绪问卷", "value": 80 },
      { "source": "学业情绪", "target": "考试焦虑量表（TAS）", "value": 80 },
      { "source": "学业情绪", "target": "考试焦虑", "value": 80 },
      // 三级(学习风格)下的
      { "source": "学习风格", "target": "soloman学习风格量表", "value": 80 },
      // 三级(学习动机)下的
      { "source": "学习动机", "target": "成就动机量表", "value": 80 },
      { "source": "学习动机", "target": "学习动力", "value": 80 },
      { "source": "学习动机", "target": "学习动机量表", "value": 80 },
      // 三级(学习状态)下的
      { "source": "学习状态", "target": "学习态度与学习方法综合测评量表", "value": 80 },
      { "source": "学习状态", "target": "中学生学习行为综合评定量表", "value": 80 },
      { "source": "学习状态", "target": "青少年学习沉醉感量表", "value": 80 },
      // 三级(意志力测评)下的
      { "source": "意志力测评", "target": "中学生意志力测验问卷", "value": 80 },
      // 三级(学习压力)下的
      { "source": "学习压力", "target": "中学生学习压力源调查问卷（SSS）", "value": 80 },
      // 三级(学习技能)下的
      { "source": "学习技能", "target": "青少年时间管理倾向量表", "value": 80 },
      { "source": "学习技能", "target": "目标管理", "value": 80 },
      { "source": "学习技能", "target": "你拖延吗？", "value": 80 },
      // 三级(学习能力)下的
      { "source": "学习能力", "target": "多元智能量表", "value": 80 },
      { "source": "学习能力", "target": "情绪智力量表", "value": 80 },
      { "source": "学习能力", "target": "“德才一体”整合智慧量表", "value": 80 },
      { "source": "学习能力", "target": "威廉斯创造力测验", "value": 80 },
      { "source": "学习能力", "target": "思维定势", "value": 80 },
      // 三级(人格)下的
      { "source": "人格", "target": "艾森克人格问卷（少年版）", "value": 80 },
      { "source": "人格", "target": "卡特尔16种人格量表", "value": 80 },
      { "source": "人格", "target": "大五人格测试量表", "value": 80 },
      { "source": "人格", "target": "12项坚毅性人格量表", "value": 80 },
      { "source": "人格", "target": "中文Frost多维度完美主义量表", "value": 80 },
      // 三级(了解自我)下的
      { "source": "了解自我", "target": "青少年心理韧性量表", "value": 80 },
      { "source": "了解自我", "target": "心理弹性", "value": 80 },
      { "source": "了解自我", "target": "心理弹性量表", "value": 80 },
      { "source": "了解自我", "target": "悦纳自我", "value": 80 },
      { "source": "了解自我", "target": "自尊量表", "value": 80 },
      { "source": "了解自我", "target": "一般自我效能感量表", "value": 80 },
      // 三级(自我管理)下的
      { "source": "自我管理", "target": "中学生自我控制量表", "value": 80 },
      // 三级(青春期)下的
      { "source": "青春期", "target": "青春期逆反心理问卷", "value": 80 },
      // 三级(同伴交往)下的
      { "source": "同伴交往", "target": "青少年孤独感量表", "value": 80 },
      { "source": "同伴交往", "target": "青少年社交焦虑量表", "value": 80 },
      { "source": "同伴交往", "target": "父母和同伴依恋量表（IPPA）", "value": 80 },
      // 三级(异性交往)下的
      { "source": "异性交往", "target": "相遇在花季", "value": 80 },
      // 三级(师生关系)下的
      { "source": "师生关系", "target": "师生关系测验", "value": 80 },
      // 三级(亲子关系)下的
      { "source": "亲子关系", "target": "中学生亲子关系问卷（学生卷）", "value": 80 },
      { "source": "亲子关系", "target": "亲子亲密度问卷", "value": 80 },
      { "source": "亲子关系", "target": "父母教养方式量表", "value": 80 },
      { "source": "亲子关系", "target": "亲子沟通方式问卷", "value": 80 },
      { "source": "亲子关系", "target": "家庭亲密度和适应性量表", "value": 80 },
      // 三级(人际交往技能)下的
      { "source": "人际交往技能", "target": "学会沟通", "value": 80 },
      { "source": "人际交往技能", "target": "领悟社会支持量表", "value": 80 },
      { "source": "人际交往技能", "target": "社会支持", "value": 80 },
      { "source": "人际交往技能", "target": "校园欺凌", "value": 80 },
      { "source": "人际交往技能", "target": "当冲突在靠近", "value": 80 },
      { "source": "人际交往技能", "target": "人际边界", "value": 80 },
      // 三级(职业生涯)下的
      { "source": "职业生涯", "target": "Super职业价值观量表（WVI）", "value": 80 },
      { "source": "职业生涯", "target": "职业价值观", "value": 80 },
      { "source": "职业生涯", "target": "决策风格", "value": 80 },
      { "source": "职业生涯", "target": "生涯规划书", "value": 80 },
      // 三级(学业生涯)下的
      { "source": "学业生涯", "target": "兴趣知多少", "value": 80 },
      { "source": "学业生涯", "target": "入学适应", "value": 80 },
      // 三级(整体满意度)下的
      { "source": "整体满意度", "target": "多维学生生活满意度量表", "value": 80 },
      // 三级(压力)下的
      { "source": "压力", "target": "青少年生活事件量表", "value": 80 },
      { "source": "压力", "target": "知觉压力量表", "value": 80 },
      { "source": "压力", "target": "中小学生压力状态评估问卷", "value": 80 },
      // 三级(适应)下的
      { "source": "适应", "target": "中学生心理适应性量表", "value": 80 },
      { "source": "适应", "target": "思维培养", "value": 80 },
      { "source": "适应", "target": "适应变化", "value": 80 },
      // 三级(应对)下的
      { "source": "应对", "target": "应对方式问卷", "value": 80 },
      { "source": "应对", "target": "简易应对方式问卷", "value": 80 },
      // 三级(行为)下的
      { "source": "行为", "target": "青少年病理性互联网使用量表", "value": 80 },
      { "source": "行为", "target": "中学生手机依赖量表", "value": 80 },
      { "source": "行为", "target": "青少年攻击性问卷", "value": 80 },
      { "source": "行为", "target": "Buss-Warren攻击问卷", "value": 80 },
      { "source": "行为", "target": "利他行为量表（SRAS-DR）", "value": 80 },
      { "source": "行为", "target": "网络成瘾", "value": 80 },
      // 三级(生命健康教育)下的
      { "source": "生命健康教育", "target": "生命之花", "value": 80 },
      // 三级(情绪觉察)下的
      { "source": "情绪觉察", "target": "情绪我懂你", "value": 80 },
      // 三级(情绪调节)下的
      { "source": "情绪调节", "target": "情绪调节量表", "value": 80 },
      { "source": "情绪调节", "target": "情绪管理", "value": 80 },
      { "source": "情绪调节", "target": "掌控情绪", "value": 80 },
      { "source": "情绪调节", "target": "情绪调节自我效能感量表", "value": 80 },
      // 三级(情感培养)下的
      { "source": "情感培养", "target": "中文版人际反应指针量表", "value": 80 },
      { "source": "情感培养", "target": "青少年宽恕倾向问卷", "value": 80 },
      // 五级(偏执)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "偏执", "value": 20 },
      { "source": "思维定势", "target": "偏执", "value": 20 },
      { "source": "思维培养", "target": "偏执", "value": 20 },
      // 五级(焦虑)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "焦虑", "value": 20 },
      { "source": "焦虑自评量表", "target": "焦虑", "value": 20 },
      { "source": "青少年学业情绪问卷", "target": "焦虑", "value": 20 },
      { "source": "考试焦虑量表（TAS）", "target": "焦虑", "value": 20 },
      { "source": "考试焦虑", "target": "焦虑", "value": 20 },
      { "source": "学习动力", "target": "焦虑", "value": 20 },
      { "source": "学习动机量表", "target": "焦虑", "value": 20 },
      { "source": "中学生学习行为综合评定量表", "target": "焦虑", "value": 20 },
      { "source": "青少年社交焦虑量表", "target": "焦虑", "value": 20 },
      { "source": "青少年生活事件量表", "target": "焦虑", "value": 20 },
      { "source": "知觉压力量表", "target": "焦虑", "value": 20 },
      { "source": "中小学生压力状态评估问卷", "target": "焦虑", "value": 20 },
      { "source": "中学生心理适应性量表", "target": "焦虑", "value": 20 },
      { "source": "情绪我懂你", "target": "焦虑", "value": 20 },
      // 五级(抑郁)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "抑郁", "value": 20 },
      { "source": "PHQ-9抑郁自评量表", "target": "抑郁", "value": 20 },
      { "source": "流调中心抑郁问卷（CES-D）", "target": "抑郁", "value": 20 },
      { "source": "抑郁自评量表", "target": "抑郁", "value": 20 },
      { "source": "青少年学业情绪问卷", "target": "抑郁", "value": 20 },
      { "source": "学习态度与学习方法综合测评量表", "target": "抑郁", "value": 20 },
      { "source": "中学生学习行为综合评定量表", "target": "抑郁", "value": 20 },
      { "source": "中学生学习压力源调查问卷（SSS）", "target": "抑郁", "value": 20 },
      { "source": "艾森克人格问卷（少年版）", "target": "抑郁", "value": 20 },
      { "source": "青少年心理韧性量表", "target": "抑郁", "value": 20 },
      { "source": "心理弹性", "target": "抑郁", "value": 20 },
      { "source": "心理弹性量表", "target": "抑郁", "value": 20 },
      { "source": "悦纳自我", "target": "抑郁", "value": 20 },
      { "source": "中学生自我控制量表", "target": "抑郁", "value": 20 },
      { "source": "青春期逆反心理问卷", "target": "抑郁", "value": 20 },
      { "source": "青少年孤独感量表", "target": "抑郁", "value": 20 },
      { "source": "亲子亲密度问卷", "target": "抑郁", "value": 20 },
      { "source": "青少年生活事件量表", "target": "抑郁", "value": 20 },
      { "source": "知觉压力量表", "target": "抑郁", "value": 20 },
      { "source": "中小学生压力状态评估问卷", "target": "抑郁", "value": 20 },
      { "source": "中学生心理适应性量表", "target": "抑郁", "value": 20 },
      { "source": "适应变化", "target": "抑郁", "value": 20 },
      { "source": "情绪我懂你", "target": "抑郁", "value": 20 },
      { "source": "情绪调节量表", "target": "抑郁", "value": 20 },
      { "source": "情绪管理", "target": "抑郁", "value": 20 },
      { "source": "掌控情绪", "target": "抑郁", "value": 20 },
      { "source": "情绪调节自我效能感量表", "target": "抑郁", "value": 20 },
      // 五级(孤独)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "孤独", "value": 20 },
      { "source": "艾森克人格问卷（少年版）", "target": "孤独", "value": 20 },
      { "source": "大五人格测试量表", "target": "孤独", "value": 20 },
      { "source": "青春期逆反心理问卷", "target": "孤独", "value": 20 },
      { "source": "青少年孤独感量表", "target": "孤独", "value": 20 },
      { "source": "校园欺凌", "target": "孤独", "value": 20 },
      { "source": "当冲突在靠近", "target": "孤独", "value": 20 },
      { "source": "人际边界", "target": "孤独", "value": 20 },
      // 五级(强迫)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "强迫", "value": 20 },
      { "source": "学习态度与学习方法综合测评量表", "target": "强迫", "value": 20 },
      { "source": "中学生学习行为综合评定量表", "target": "强迫", "value": 20 },
      { "source": "目标管理", "target": "强迫", "value": 20 },
      { "source": "思维定势", "target": "强迫", "value": 20 },
      { "source": "中文Frost多维度完美主义量表", "target": "强迫", "value": 20 },
      { "source": "一般自我效能感量表", "target": "强迫", "value": 20 },
      { "source": "思维培养", "target": "强迫", "value": 20 },
      // 五级(敌对)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "敌对", "value": 20 },
      { "source": "大五人格测试量表", "target": "敌对", "value": 20 },
      { "source": "中学生自我控制量表", "target": "敌对", "value": 20 },
      { "source": "校园欺凌", "target": "敌对", "value": 20 },
      { "source": "当冲突在靠近", "target": "敌对", "value": 20 },
      { "source": "青少年攻击性问卷", "target": "敌对", "value": 20 },
      { "source": "Buss-Warren攻击问卷", "target": "敌对", "value": 20 },
      // 五级(适应不良)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "适应不良", "value": 20 },
      { "source": "中学生心理适应性量表", "target": "适应不良", "value": 20 },
      { "source": "思维培养", "target": "适应不良", "value": 20 },
      { "source": "适应变化", "target": "适应不良", "value": 20 },
      // 五级(恐惧)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "恐惧", "value": 20 },
      { "source": "青少年孤独感量表", "target": "恐惧", "value": 20 },
      { "source": "青少年社交焦虑量表", "target": "恐惧", "value": 20 },
      { "source": "校园欺凌", "target": "恐惧", "value": 20 },
      // 五级(睡眠)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "睡眠", "value": 20 },
      { "source": "失眠严重指数量表（ISI）", "target": "睡眠", "value": 20 },
      { "source": "中学生学习压力源调查问卷（SSS）", "target": "睡眠", "value": 20 },
      { "source": "青少年生活事件量表", "target": "睡眠", "value": 20 },
      { "source": "知觉压力量表", "target": "睡眠", "value": 20 },
      { "source": "中小学生压力状态评估问卷", "target": "睡眠", "value": 20 },
      { "source": "情绪调节量表", "target": "睡眠", "value": 20 },
      { "source": "情绪管理", "target": "睡眠", "value": 20 },
      { "source": "掌控情绪", "target": "睡眠", "value": 20 },
      { "source": "情绪调节自我效能感量表", "target": "睡眠", "value": 20 },
      // 五级(饮食)的父级
      { "source": "中小学生心理健康诊断测验（MHT)", "target": "饮食", "value": 20 },
      { "source": "悦纳自我", "target": "饮食", "value": 20 },
      { "source": "情绪调节量表", "target": "饮食", "value": 20 },
      { "source": "情绪管理", "target": "饮食", "value": 20 },
      { "source": "掌控情绪", "target": "饮食", "value": 20 },
      { "source": "情绪调节自我效能感量表", "target": "饮食", "value": 20 },
      // 五级(其他)的父级
      { "source": "Super职业价值观量表（WVI）", "target": "其他", "value": 20 },
      { "source": "职业价值观", "target": "其他", "value": 20 },
      { "source": "决策风格", "target": "其他", "value": 20 },
      { "source": "生涯规划书", "target": "其他", "value": 20 },
      { "source": "兴趣知多少", "target": "其他", "value": 20 },
      { "source": "入学适应", "target": "其他", "value": 20 },
      { "source": "soloman学习风格量表", "target": "其他", "value": 20 },
      { "source": "中学生意志力测验问卷", "target": "其他", "value": 20 },
      { "source": "青少年时间管理倾向量表", "target": "其他", "value": 20 },
      { "source": "你拖延吗？", "target": "其他", "value": 20 },
      { "source": "多元智能量表", "target": "其他", "value": 20 },
      { "source": "情绪智力量表", "target": "其他", "value": 20 },
      { "source": "“德才一体”整合智慧量表", "target": "其他", "value": 20 },
      { "source": "威廉斯创造力测验", "target": "其他", "value": 20 },
      { "source": "成就动机量表", "target": "其他", "value": 20 },
      { "source": "相遇在花季", "target": "其他", "value": 20 },
      { "source": "青少年学习沉醉感量表", "target": "其他", "value": 20 },
      { "source": "师生关系测验", "target": "其他", "value": 20 },
      { "source": "中学生亲子关系问卷（学生卷）", "target": "其他", "value": 20 },
      { "source": "父母教养方式量表", "target": "其他", "value": 20 },
      { "source": "亲子沟通方式问卷", "target": "其他", "value": 20 },
      { "source": "家庭亲密度和适应性量表", "target": "其他", "value": 20 },
      { "source": "学会沟通", "target": "其他", "value": 20 },
      { "source": "领悟社会支持量表", "target": "其他", "value": 20 },
      { "source": "社会支持", "target": "其他", "value": 20 },
      { "source": "自尊量表", "target": "其他", "value": 20 },
      { "source": "父母和同伴依恋量表（IPPA）", "target": "其他", "value": 20 },
      { "source": "卡特尔16种人格量表", "target": "其他", "value": 20 },
      { "source": "12项坚毅性人格量表", "target": "其他", "value": 20 },
      { "source": "多维学生生活满意度量表", "target": "其他", "value": 20 },
      { "source": "应对方式问卷", "target": "其他", "value": 20 },
      { "source": "简易应对方式问卷", "target": "其他", "value": 20 },
      { "source": "青少年病理性互联网使用量表", "target": "其他", "value": 20 },
      { "source": "中学生手机依赖量表", "target": "其他", "value": 20 },
      { "source": "利他行为量表（SRAS-DR）", "target": "其他", "value": 20 },
      { "source": "生命之花", "target": "其他", "value": 20 },
      { "source": "中文版人际反应指针量表", "target": "其他", "value": 20 },
      { "source": "青少年宽恕倾向问卷", "target": "其他", "value": 20 },
      { "source": "网络成瘾", "target": "其他", "value": 20 },
      // 五级下的(指向心理健康状态)
      { "source": "偏执", "target": "心理健康状态", "value": 100 },
      { "source": "焦虑", "target": "心理健康状态", "value": 200 },
      { "source": "抑郁", "target": "心理健康状态", "value": 100 },
      { "source": "孤独", "target": "心理健康状态", "value": 100 },
      { "source": "强迫", "target": "心理健康状态", "value": 100 },
      { "source": "敌对", "target": "心理健康状态", "value": 100 },
      { "source": "适应不良", "target": "心理健康状态", "value": 100 },
      { "source": "恐惧", "target": "心理健康状态", "value": 100 },
      { "source": "睡眠", "target": "心理健康状态", "value": 100 },
      { "source": "饮食", "target": "心理健康状态", "value": 100 },
      { "source": "其他", "target": "心理健康状态", "value": 1000 },

    ]
  };
  let myChartSankeyMain = echarts.init(document.getElementById("sankeyMain"));
  let optionSankey = {
    title: {
      text: ''
    },
    tooltip: {
      trigger: 'item',
      triggerOn: 'mousemove'
    },
    series: [
      {
        type: 'sankey',
        data: data.nodes,
        links: data.links,
        layoutIterations: 0,
        emphasis: {
          focus: 'adjacency'
        },
        draggable: false,
        levels: [
          {
            depth: 0,
            label: {
              fontSize: 16,
              color: '#fff',
              borderColor: '#000000',
            },
            itemStyle: {
              color: '#fbb4ae',
              borderWidth: 100,
            },
            lineStyle: {
              color: 'source',
              opacity: 0.6,
            }
          },
          {
            depth: 1,
            label: {
              fontSize: 14,
              color: '#fff',
              borderColor: '#000000',
            },
            itemStyle: {
              color: '#b3cde3',
              borderWidth: 100,
            },
            lineStyle: {
              color: 'source',
              opacity: 0.6,
            }
          },
          {
            depth: 2,
            label: {
              fontSize: 12,
              color: '#fff',
              borderColor: '#000000',
            },
            itemStyle: {
              color: '#ccebc5'
            },
            lineStyle: {
              color: 'source',
              opacity: 0.6
            }
          },
          {
            depth: 3,
            label: {
              fontSize: 10,
              color: '#fff',
              borderColor: '#000000',
            },
            itemStyle: {
              color: '#decbe4',
              borderWidth: 100,
            },
            lineStyle: {
              color: 'source',
              opacity: 0.6
            }
          },
          {
            depth: 4,
            label: {
              fontSize: 10,
              color: '#fff',
              borderColor: '#000000',
            },
            itemStyle: {
              color: '#ccebc5'
            },
            lineStyle: {
              color: 'source',
              opacity: 0.6
            }
          }
        ],
        lineStyle: {
          curveness: 0.5
        }
      }
    ]
  };
  myChartSankeyMain.setOption(optionSankey);
}